export default function translateClearingStatus(status) {
    if (status === "confirmed") return "Angenommen";
    else if (status === "cancelled") return "Abgelehnt";
    else if (status === "open") return "Ausstehend";
    else if (status === "overdue") return "Überfällig";
    else return "-/-";
}
